<template>
  <div id="app-main" class="data-list">
    <el-container>
      <div class="corner corner1" />
      <div class="corner corner2" />
      <div class="corner corner3" />
      <div class="corner corner4" />
      <el-aside width="300px" class="category-wrap">
        <SideBanner />
      </el-aside>
      <el-main>
        <div class="wrapper">
          <el-descriptions :title="'『  ' + resource.title + '  』'" :column="1" border>
            <el-descriptions-item v-for="(v, i) in values" :key="'value' + i" label-class-name="desc-item-label" :label="v.field">
              {{ v.value }}
            </el-descriptions-item>

            <!-- 选择显示主题分类  -->
            <el-descriptions-item v-if="category !== undefined" label-class-name="desc-item-label" label="主题分类">{{
              category.title
            }}</el-descriptions-item>

            <!-- 动态属性 -->
            <el-descriptions-item v-if="propList.length > 0" label-class-name="desc-item-label" label="属性">
              <span v-for="p in propList" :key="p.prop_id" style="margin-right:5px">
                {{ p.title }}
              </span>
            </el-descriptions-item>
          </el-descriptions>

          <!-- 阅读按钮 -->
          <router-link :to="{ name: 'Reader', params: { resId: resId, type: resource.type } }" target="_self">
            <el-button type="primary" plain icon="el-icon-reading" style="margin-top: 40px"> 在线阅读 </el-button>
          </router-link>

          <!-- 内容摘要 -->
          <div v-if="resource.type !== 'db' && resource.type !== 'ds' && resource.content" class="resource-intro">
            <Title title="内容摘要" />
            <div class="content-wrap" style="text-align: left">
              <div class="content" v-html="resource.content" />
            </div>
          </div>

          <!-- 人物简介 -->
          <div v-if="resource.type !== 'db' && resource.type !== 'ds' && personList.length > 0" class="person-intro-wrap">
            <div v-for="personId in personList" :key="'person' + personId" class="person-intro">
              <PersonIntro :person-id="personId" />
            </div>
          </div>

          <!-- 关联人物 -->
          <div v-if="resource.type === 'ds' && personList.length > 0" class="person-intro-wrap">
            <PersonInfo v-for="personId in personList" :key="'person' + personId" :person-id="personId" />
          </div>
          <div style="clear:both;" />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// 资源类型常量
import { typeName } from '@/constants/ResourceType'
import Title from '@/components/Title'
import SideBanner from '@/components/SideBanner'
import PersonIntro from './components/PersonIntro'
import PersonInfo from './components/PersonInfo'
// 接口
import { resourceInfo } from '@/api/ResourceApi'
// store
import { mapGetters } from 'vuex'
export default {
  name: 'ResourceInfo',
  components: {
    Title,
    SideBanner,
    PersonIntro,
    PersonInfo
  },
  filters: {
    mapType(type) {
      return typeName[type]
    }
  },
  data() {
    return {
      resId: parseInt(this.$route.params.resId),
      resource: { title: '正在加载...' },
      values: [],
      type: this.$route.params.type,
      resourceList: [],
      personList: [],
      propList: []
    }
  },

  computed: {
    typeName() {
      return typeName[this.resource.type]
    },
    ...mapGetters(['categoryList']),
    category() {
      return this.categoryList.find((cat) => cat.id === this.resource.category)
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.resId = to.params.resId
    this.type = to.params.type
    this.pageNum = 1
    this.fetchResourceInfo()
    next()
  },
  created() {
    this.fetchResourceInfo()
  },

  methods: {
    fetchResourceInfo() {
      resourceInfo(this.resId).then((resp) => {
        if (resp.code === 0) {
          this.resource = resp.resource
          this.propList = resp.props
          this.values = resp.values
          this.personList = resp.persons
          for (let index = 0; index < this.values.length; index++) {
            const value = this.values[index]
            // 去掉关联人物
            if (value['fieldId'] === 5) {
              this.personList = JSON.parse(value['value'])
              this.values.splice(index, 1)
            }

            // 如果是散见史料则将题名改成来源文献
            if (this.resource.type === 'ds' && value['field'] === '题名') {
              value['field'] = '来源文献'
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
#app-main {
  min-height: 800px;
  width: 1200px;
  margin: 0 auto;
}

.el-container {
  padding: 9px;
  border: 1px solid #d5d5d4;
  width: 1195px;
  min-height: 800px;
  margin-bottom: 30px;
  position: relative;
  left: 0px;
  top: 0px;
  background: url(../../assets/imgs/block-bg.png);
  // 四个角方块
  .corner {
    width: 12px;
    height: 12px;
    border: 1px solid #d5d5d4;
    position: absolute;
  }
  // 方块1
  .corner1 {
    top: -6px;
    left: -6px;
  }
  // 方块2
  .corner2 {
    top: -6px;
    right: -6px;
  }
  // 方块3
  .corner3 {
    bottom: -6px;
    left: -6px;
  }
  // 方块4
  .corner4 {
    right: -6px;
    bottom: -6px;
  }
}

.el-aside {
  overflow: hidden;
  height: 100%;
}

//数据列表
.el-main {
  // border: 1px solid #D6D5D5;
  padding: 5px;
  margin-left: 20px;
  background-color: #fff;
  border: 1px solid #d5d5d4;

  .wrapper {
    // background: url(../../assets/imgs/list-data-bg.png) no-repeat;
    background-size: 100% 99%;
    padding: 20px;
    background-color: #fff;
  }
}

.content-wrap {
  padding: 20px;
  .content {
    line-height: 30px;
    text-indent: 2em;
  }
}

.el-descriptions {
  ::v-deep .el-descriptions__title {
    font-size: 22px;
    font-weight: bold;
  }
  ::v-deep .desc-item-label {
    font-size: 14px;
    font-weight: bold;
    padding: 0 12px;
    width: 100px;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-ideograph;
    color: #595959;
  }
  ::v-deep .el-descriptions-item__content {
    color: #000;
  }
}
</style>
